export type msiKinds = 'minus500' | 'msiOnOfferMinMsi' | 'msiOnOfferNextMsi' | 'msiOnMsiReached' | 'msiOff'

export const msiTypesEquivalences = {
  0: 'msiOff',
  1: 'minus500',
  2: 'msiOnOfferMinMsi',
  3: 'msiOnMsiReached',
  4: 'msiOnOfferNextMsi',
};
